import { createSlice } from "@reduxjs/toolkit";
import { getListVoucherDetail } from "../../../api/customer/redeemvoucher/redeemVoucher";

const initialState = {
  voucherOfCustomer: null,
  isLoading: false,
};

const redeemDisCountCustomer = createSlice({
  name: "redeemDisCountCustomer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getListVoucherDetail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListVoucherDetail.fulfilled, (state, action) => {
        state.voucherOfCustomer = action.payload;
        state.isLoading = false;
      })
      .addCase(getListVoucherDetail.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const {} = redeemDisCountCustomer.actions;

export default redeemDisCountCustomer.reducer;
